import {touchstartScrollFix} from "./globalUtilities";

var mobileAccordionTabsConfig = {
    navigation: ".tabNav",
    container: ".tabContainer",
    activeTab: 1,
    activeClass: "active",
    scrollOffset: false,
    accordScreen: 767,
    animation: false,
    toggleClose: true,
    openWithUrl: false,
    callback: function () {
        touchstartScrollFix("js-tab-title-overlay");
    }
};

module.exports = {
    mobileAccordionTabsConfig: mobileAccordionTabsConfig
};
